import axios from "axios";
import { REACT_APP_DOMAIN_URL } from "features/shared/constants";
import { GetStockStoreModel } from "../core/domain/get-stock-store.model";
import { InsertNewOrderModel } from "../core/domain/insert-new-order.model";
import {
  InsertNewOrderParam,
  ProductParam,
  newOrdersParam,
  updateStatus,
  receiveOrdersParam,
  updatePayBillingParam,
  dispatchOrderParam,
  updatReviewParam,
  stockDeliveryApprovalParam,
  updateCancelledStatus,
  updateBillingOrderParam,
  updateOrderItemsParam,
  stockOrderSettingsProductParam,
  FranchiseePayBillParam,
  updatePenelizedPayBillingParam,
  PriceIncreaseParam,
  minimumOrderAmountParam,
  updateCommitedDeliveryDate,
  insertNewProductCostDate,
  CommentParam,
  stockInitialOrderReviewParam,
  getOrderID,
  UpdatedSalesInvoice,
  RatingParam,
  ProductReviewsParam,
  ProductReviewsResponse,
  ProductReview,
  OrderedProductsEdit,
  OrderedInfosEdit,
  FetchCurrentStockparam,
  StaggeredReceive,
  SettingsProductStocksChange,
} from "../core/stock-ordering.params";
import { GetStockProductModel } from "../core/domain/get-stock-product.model";
import { GetStockOrdersModel } from "../core/domain/get-stock-orders.model";
import { GetProductDataModel } from "../core/domain/get-product-data.model";
import { GetPayBillingSiModel } from "../core/domain/get-pay-billing-si.model";
import { DeliveryScheduleModel } from "../core/domain/delivery-schedule.model";
import { OverdueTaskModel } from "../core/domain/overdue-task.model";
import { StockOrderingSettingsProducts } from "../core/domain/stock-ordering-all-products.model";
import { StockOrderProductModel } from "../core/domain/stock-order-product.model";
import { StockOrderAllStoreModel } from "../core/domain/stock-order-all-store.model";
import { GetPriceHistoryModel } from "../core/domain/get-price-history.model";
import { GetProductLatestPriceModel } from "../core/domain/getProductLatestPrice.model";
import { GetMinimumTotalAmountDataModel } from "../core/domain/get-minimum-total-amount.model";
import { GetProductCostChangeHistoryModel } from "../core/domain/ProductCostChangeHistory.model";
import { CommentDataModel } from "../core/domain/comment-data.model";
import { UserNotificationModel } from "../core/domain/user-notification.model";
import { ActiveProcessModel } from "../core/domain/actove-process.model";
import { StockInventoryCurrentStock } from "../core/domain/stock-inventory.model";
import { ProductReviewsData } from "../presentation/slices/product-reviews.slice";
import { GetOrderConfigModel } from "../core/domain/order-config.model";

export interface GetStockOrderStoresResponse {
  data: {
    message: string;
    data: GetStockStoreModel;
  };
}

export interface InsertNewOrderResponse {
  data: {
    message: string;
    data: InsertNewOrderModel;
  };
}

export interface GetStockOrderProductsResponse {
  data: {
    message: string;
    data: GetStockProductModel;
  };
}

export interface GetStockOrdersResponse {
  data: {
    message: string;
    data: GetStockOrdersModel;
  };
}

export interface GetProductDataResponse {
  data: {
    message: string;
    data: GetProductDataModel;
  };
}

export interface updateNewOrdersResponse {
  data: {
    message: string;
    data: string;
  };
}

export interface updateReviewOrdersResponse {
  data: {
    message: string;
    data: string;
  };
}

export interface updateConfirmOrdersResponse {
  data: {
    message: string;
    data: string;
  };
}

export interface stockDispatchOrdersResponse {
  data: {
    message: string;
  };
}

export interface updateEnrouteOrdersResponse {
  data: {
    message: string;
    data: string;
  };
}

export interface updateReceiveOrdersResponse {
  data: {
    message: string;
    data: string;
  };
}

export interface updateBillingOrdersResponse {
  data: {
    message: string;
    data: string;
  };
}

export interface updatePayBillingOrdersResponse {
  data: {
    message: string;
    data: string;
  };
}

export interface updateConfirmPaymentResponse {
  data: {
    message: string;
    data: string;
  };
}

export interface stockDeliveryApprovalResponse {
  data: {
    message: string;
    data: string;
  };
}

export interface updateOrderCancelledResponse {
  data: {
    message: string;
    data: string;
  };
}

export interface GetPayBillingSiResponse {
  data: {
    message: string;
    data: GetPayBillingSiModel;
  };
}
export interface GetDeliveryScheduleResponse {
  data: {
    message: string;
    data: Array<DeliveryScheduleModel>;
  };
}

export interface updateOrderItemsResponse {
  data: {
    message: string;
  };
}

export interface GetStockOrderSettingProductsResponse {
  data: {
    message: string;
    data: StockOrderingSettingsProducts;
  };
}

export interface stockOrderCreateProductResponse {
  data: {
    message: string;
  };
}

export interface GetStockOrderSettingProductsEditResponse {
  data: {
    message: string;
    data: StockOrderProductModel;
  };
}

export interface GetStockOrderAllStoresResponse {
  data: {
    message: string;
    data: StockOrderAllStoreModel;
  };
}

export interface stockOrderEditProductResponse {
  data: {
    message: string;
  };
}

export interface stockOrderSettingsProductInfoChangesResponse {
  data: {
    message: string;
  };
}

export interface updateFranchiseePayBillResponse {
  data: {
    message: string;
  };
}

export interface updatePenalizedPayBillingOrdersResponse {
  data: {
    message: string;
  };
}

export interface GetMinimumTotalAmountDataResponse {
  data: {
    message: string;
    data: GetMinimumTotalAmountDataModel;
  };
}

export interface GetMinimumTotalAmountHistoryResponse {
  data: {
    message: string;
    data: Array<GetMinimumTotalAmountDataModel>;
  };
}

export interface PostRatingResponse {
  data: {
    message: string;
  };
}

export interface GetOrderConfigResponse {
  data: {
    message: string;
    data: GetOrderConfigModel;
  };
}

export interface BatchProductReviewsParam {
  productIds: string[];
}

export interface BatchProductReviewsResponse {
  success: boolean;
  message?: string;
  data?: {
    [productId: string]: {
      product_id: string;
      product_name: string;
      total_reviews: number;
      average_rating: number;
      rating_breakdown: {
        "5": number;
        "4": number;
        "3": number;
        "2": number;
        "1": number;
      };
      reviews: ProductReview[];
    };
  };
}

export function GetStockOrderStoresRepository(
  store_id: string
): Promise<GetStockOrderStoresResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/stock/order/stores${store_id}`, {
    withCredentials: true,
  });
}

export interface GetOverdueTaskResponse {
  data: {
    message: string;
    data: Array<OverdueTaskModel>;
  };
}

export interface GetPriceHistoryResponse {
  data: {
    message: string;
    data: GetPriceHistoryModel;
  };
}

export interface GetProductLatestPriceResponse {
  data: {
    message: string;
    data: GetProductLatestPriceModel;
  };
}

export interface insertPriceIncreaseResponse {
  data: {
    message: string;
  };
}

export interface updateMinimumTotalAmountResponse {
  data: {
    message: string;
  };
}

export interface updateCommitedDeliveryResponse {
  data: {
    message: string;
  };
}

export interface insertNewProductCostResponse {
  data: {
    message: string;
  };
}

export interface GetProductCostChangeHistoryResponse {
  data: {
    message: string;
    data: Array<GetProductCostChangeHistoryModel>;
  };
}

export interface PostCommentResponse {
  data: {
    message: string;
  };
}

export interface GetOrderCommentResponse {
  data: {
    message: string;
    data: CommentDataModel;
  };
}

export interface updateCommentReactResponse {
  data: {
    message: string;
  };
}

export interface stockInitialOrderReviewResponse {
  data: {
    message: string;
  };
}

export interface updatedSalesInvoiceApprovalResponse {
  data: {
    message: string;
  };
}

export interface stockUserNotificationResponse {
  data: {
    message: string;
    data: UserNotificationModel | undefined;
  };
}

export interface updateNotificationSeenResponse {
  data: {
    message: string;
  };
}

export interface stockActiveProcessResponse {
  data: {
    message: string;
    data: ActiveProcessModel | undefined;
  };
}

export interface stockInventoryFetchCurrentStockResponse {
  data: {
    message: string;
    data: StockInventoryCurrentStock | undefined;
  };
}

export interface updateNewProductStockResponse {
  data: {
    message: string;
  };
}

export interface stockOrderedEditProductResponse {
  data: {
    message: string;
  };
}

export interface stockOrderedEditInfoResponse {
  data: {
    message: string;
  };
}
export interface staggeredReceiveResponse {
  data: {
    message: string;
  };
}
export interface staggeredDispatchResponse {
  data: {
    message: string;
  };
}

export function InsertNewOrderRepository(
  param: InsertNewOrderParam
): Promise<InsertNewOrderResponse> {
  return axios.post(`${REACT_APP_DOMAIN_URL}api/stock/new/order`, param, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  });
}

export function GetStockOrderProductsRepository(
  param: ProductParam
): Promise<GetStockOrderProductsResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/stock/order/products`, {
    params: param,
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });
}

export function GetStockOrdersRepository(param: {
  query: string;
  view: string | undefined;
  processId: number | undefined;
}): Promise<GetStockOrdersResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/stock/order/${param.view}/${param.processId}${param.query}`,
    {
      withCredentials: true,
    }
  );
}

export function GetProductDataRepository(
  param: getOrderID
): Promise<GetProductDataResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/stock/ordered/products`, {
    params: param,
    withCredentials: true,
  });
}

export function updateNewOrdersRepository(
  param: newOrdersParam
): Promise<updateNewOrdersResponse> {
  return axios.post(`${REACT_APP_DOMAIN_URL}api/stock/update-order`, param, {
    withCredentials: true,
  });
}

export function updateReviewOrdersRepository(
  param: updatReviewParam
): Promise<updateReviewOrdersResponse> {
  return axios.post(`${REACT_APP_DOMAIN_URL}api/stock/review-order`, param, {
    withCredentials: true,
  });
}

export function updateConfirmOrdersRepository(
  param: updateStatus
): Promise<updateConfirmOrdersResponse> {
  return axios.post(`${REACT_APP_DOMAIN_URL}api/stock/confirm-order`, param, {
    withCredentials: true,
  });
}

export function stockDispatchOrdersRepository(
  param: dispatchOrderParam
): Promise<stockDispatchOrdersResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/order/${param.id}/dispatch`,
    param.data,
    {
      withCredentials: true,
    }
  );
}

export function updateReceiveOrdersRepository(
  param: receiveOrdersParam
): Promise<updateReceiveOrdersResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/order/${param.id}/receive`,
    param.data,
    {
      withCredentials: true,
    }
  );
}

export function updateBillingOrdersRepository(
  param: updateBillingOrderParam
): Promise<updateBillingOrdersResponse> {
  return axios.post(`${REACT_APP_DOMAIN_URL}api/stock/update-billing`, param, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  });
}

export function updatePayBillingOrdersRepository(
  param: updatePayBillingParam
): Promise<updatePayBillingOrdersResponse> {
  return axios.post(`${REACT_APP_DOMAIN_URL}api/stock/pay-billing`, param, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  });
}

export function updateConfirmPaymentRepository(
  param: updateStatus
): Promise<updateConfirmPaymentResponse> {
  return axios.post(`${REACT_APP_DOMAIN_URL}api/stock/confirm-payment`, param, {
    withCredentials: true,
  });
}

export function stockDeliveryApprovalRepository(
  param: stockDeliveryApprovalParam
): Promise<stockDeliveryApprovalResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/order/${param.orderId}/${param.role}/${param.action}`,
    param.data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    }
  );
}

export function updateOrderCancelledRepository(
  param: updateCancelledStatus
): Promise<updateOrderCancelledResponse> {
  return axios.post(`${REACT_APP_DOMAIN_URL}api/stock/cancelled`, param, {
    withCredentials: true,
  });
}

export function GetPayBillingSiRepository(
  param: string
): Promise<GetPayBillingSiResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/stock/pay-billing${param}`, {
    withCredentials: true,
  });
}

export function GetDeliveryScheduleRepository(): Promise<GetDeliveryScheduleResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/stock/schedule/delivery`, {
    withCredentials: true,
  });
}

export function updateOrderItemsRepository(
  param: updateOrderItemsParam
): Promise<updateOrderItemsResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/update/order-items`,
    param,
    {
      withCredentials: true,
    }
  );
}

export function GetOverdueTaskRepository(): Promise<GetOverdueTaskResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/stock/get/overdue-task`, {
    withCredentials: true,
  });
}

export function GetStockOrderSettingProductsRepository(
  param: string
): Promise<GetStockOrderSettingProductsResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/products${param}`,
    {
      withCredentials: true,
    }
  );
}

export function stockOrderCreateProductRepository(
  param: stockOrderSettingsProductParam
): Promise<stockOrderCreateProductResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/create-product`,
    param,
    {
      withCredentials: true,
    }
  );
}

export function GetStockOrderSettingProductsEditRepository(
  param: string
): Promise<GetStockOrderSettingProductsEditResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/edit-product/${param}`,

    {
      withCredentials: true,
    }
  );
}

export function GetStockOrderAllStoresRepository(): Promise<GetStockOrderAllStoresResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/all-store`,

    {
      withCredentials: true,
    }
  );
}

export function stockOrderEditProductRepository(param: {
  id: string;
  productData: stockOrderSettingsProductParam;
}): Promise<stockOrderEditProductResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/edit-product/${param.id}`,
    param.productData,
    {
      withCredentials: true,
    }
  );
}

export function stockOrderSettingsProductInfoChangesRepository(
  param: SettingsProductStocksChange
): Promise<stockOrderSettingsProductInfoChangesResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/change/product/${param.changeType}`,
    param.payload,
    {
      withCredentials: true,
    }
  );
}

export function updateFranchiseePayBillRepository(
  param: FranchiseePayBillParam
): Promise<updateFranchiseePayBillResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/order/franchisee-pay-bill`,
    param,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    }
  );
}

export function updatePenalizedPayBillingOrdersRepository(
  param: updatePenelizedPayBillingParam
): Promise<updatePenalizedPayBillingOrdersResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/order/stock/order/penalized-pay-bill`,
    param,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    }
  );
}

export function GetPriceHistoryRepository(
  param: string
): Promise<GetPriceHistoryResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/product-price-history${param}`,
    {
      withCredentials: true,
    }
  );
}

export function GetProductLatestPriceRepository(): Promise<GetProductLatestPriceResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/stock/settings/price-increase`, {
    withCredentials: true,
  });
}

export function insertPriceIncreaseRepository(
  param: PriceIncreaseParam
): Promise<insertPriceIncreaseResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/price-increase`,
    param,
    {
      withCredentials: true,
    }
  );
}

export function updateMinimumTotalAmountRepository(
  param: minimumOrderAmountParam
): Promise<updateMinimumTotalAmountResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/general/minimum-total-amount`,
    param,
    {
      withCredentials: true,
    }
  );
}

export function GetMinimumTotalAmountDataRepository(): Promise<GetMinimumTotalAmountDataResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/general/minimum-total-amount`,
    {
      withCredentials: true,
    }
  );
}

export function GetMinimumTotalAmountHistoryRepository(): Promise<GetMinimumTotalAmountHistoryResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/general/minimum-total-amount-history`,
    {
      withCredentials: true,
    }
  );
}

export function updateCommitedDeliveryRepository(
  param: updateCommitedDeliveryDate
): Promise<updateCommitedDeliveryResponse> {
  return axios.put(
    `${REACT_APP_DOMAIN_URL}api/stock/order/update/commited-quantity`,
    param,
    {
      withCredentials: true,
    }
  );
}

export function insertNewProductCostRepository(
  param: insertNewProductCostDate
): Promise<insertNewProductCostResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/product/price-increase-history`,
    param,
    {
      withCredentials: true,
    }
  );
}

export function GetProductCostChangeHistoryRepository(
  param: string
): Promise<GetProductCostChangeHistoryResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/stock/settings/product/price-increase-history${param}`,
    {
      withCredentials: true,
    }
  );
}

export function PostCommentRepository(
  param: CommentParam
): Promise<PostCommentResponse> {
  return axios.post(`${REACT_APP_DOMAIN_URL}api/stock/comment`, param, {
    withCredentials: true,
  });
}

export function GetOrderCommentRepository(
  param: string
): Promise<GetOrderCommentResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/stock/comment${param}`, {
    withCredentials: true,
  });
}

export function updateCommentReactRepository(param: {
  type: string;
  commentId: number;
}): Promise<updateCommentReactResponse> {
  return axios.put(`${REACT_APP_DOMAIN_URL}api/stock/comment`, param, {
    withCredentials: true,
  });
}

export function stockInitialOrderReviewRepository(
  param: stockInitialOrderReviewParam
): Promise<stockInitialOrderReviewResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/initial-order-review/${param.orderId}/${param.type}`,
    param.data,

    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    }
  );
}

export function updatedSalesInvoiceApprovalRepository(
  param: UpdatedSalesInvoice
): Promise<updatedSalesInvoiceApprovalResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/receieve-approval/approve-sales-invoice`,
    param,

    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    }
  );
}

export function stockUserNotificationRepository(): Promise<stockUserNotificationResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/stock/user/notification`, {
    withCredentials: true,
  });
}

export function updateNotificationSeenRepository(param: {
  notificationId: string;
}): Promise<updateNotificationSeenResponse> {
  return axios.put(
    `${REACT_APP_DOMAIN_URL}api/stock/user/notification`,
    param,
    {
      withCredentials: true,
    }
  );
}

export function stockActiveProcessRepository(
  param: string
): Promise<stockActiveProcessResponse> {
  return axios.get(`${REACT_APP_DOMAIN_URL}api/stock/active-process${param}`, {
    withCredentials: true,
  });
}

export function stockInventoryFetchCurrentStockRepository(
  param: FetchCurrentStockparam
): Promise<stockInventoryFetchCurrentStockResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/stock/inventory/products/${param.supplierId}/current-stock?${param.query}`,
    {
      withCredentials: true,
    }
  );
}

export function updateNewProductStockRepository(param: {
  newStock: number;
  productId: string | undefined;
}): Promise<updateNewProductStockResponse> {
  return axios.put(
    `${REACT_APP_DOMAIN_URL}api/stock/inventory/products/current-stock`,
    param,
    {
      withCredentials: true,
    }
  );
}

export function PostRatingRepository(
  param: RatingParam
): Promise<PostRatingResponse> {
  return axios.post(`${REACT_APP_DOMAIN_URL}api/stock/order/rating`, param, {
    withCredentials: true,
  });
}

// Add this function to your repository file
export const CheckExistingRatingsRepository = async (orderId: string) => {
  const response = await axios.get(
    `${REACT_APP_DOMAIN_URL}api/stock/order/rating`,
    {
      params: { orderId, action: "check" },
      withCredentials: true,
    }
  );
  return response.data;
};

// In your stock-ordering.repository.tsx
export const GetProductReviewsRepository = async (
  param: ProductReviewsParam
): Promise<ProductReviewsResponse> => {
  // Keep it as ProductReviewsResponse
  const response = await axios.get(
    `${REACT_APP_DOMAIN_URL}api/stock/product/reviews/${param.productId}`,
    {
      withCredentials: true,
    }
  );

  // Return the full response structure
  return response.data; // This includes success, message, and data
};

export const GetBatchProductReviewsRepository = async (
  param: BatchProductReviewsParam
): Promise<BatchProductReviewsResponse> => {
  const response = await axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/product/reviews/batch`,
    param,
    {
      withCredentials: true,
    }
  );
  return response.data;
};
export type { ProductReviewsResponse };

export function stockOrderedEditProductRepository(
  param: OrderedProductsEdit
): Promise<stockOrderedEditProductResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/order/${param.orderId}/edit/product`,
    param.data,
    {
      withCredentials: true,
    }
  );
}

export function stockOrderedEditInfoRepository(
  param: OrderedInfosEdit
): Promise<stockOrderedEditInfoResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/order/${param.orderId}/edit/info`,
    param.data,
    {
      withCredentials: true,
    }
  );
}

export function staggeredReceiveRepository(
  param: StaggeredReceive
): Promise<staggeredReceiveResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/order/${param.orderId}/staggered-receive`,
    param.payload,
    {
      withCredentials: true,
    }
  );
}

export function staggeredDispatchRepository(
  param: StaggeredReceive
): Promise<staggeredDispatchResponse> {
  return axios.post(
    `${REACT_APP_DOMAIN_URL}api/stock/order/${param.orderId}/staggered-dispatch`,
    param.payload,
    {
      withCredentials: true,
    }
  );
}

export function GetOrderConfigRepository(
  param?: string | undefined
): Promise<GetOrderConfigResponse> {
  return axios.get(
    `${REACT_APP_DOMAIN_URL}api/stock/order/place/config${param}`,
    {
      withCredentials: true,
    }
  );
}
